export default __webpack_public_path__ + "static/media/logo-droga5.21926614.svg";